import { Col, Popover, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import Paragraph from 'antd/lib/typography/Paragraph';
import iMessageMock from './iMessageMock.png';
import styled from 'styled-components';
import TextArea from 'antd/es/input/TextArea';
import { SegmentedMessage } from 'sms-segments-calculator';
const { Text } = Typography;

export const MessageWrapper = styled.div`
  /* Ref: https://stackoverflow.com/questions/19400183/how-to-style-chat-bubble-in-iphone-classic-style-using-css-only */
  .messages {
    margin-top: 35%;
    margin-left: 14%;
    margin-bottom: 4%;
    display: flex;
    flex-direction: column;
  }

  .message {
    border-radius: 20px;
    padding: 8px 15px;
    margin-top: 5px;
    width: 68%;
    margin-bottom: 5px;
    display: inline-block;
  }

  .yours {
    align-items: flex-start;
  }

  .yours .message {
    margin-right: 10%;
    background-color: #eee;
    position: relative;
  }

  .yours .message.last:before {
    content: '';
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: -7px;
    height: 20px;
    width: 20px;
    background: #eee;
    border-bottom-right-radius: 15px;
  }
  .yours .message.last:after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: -10px;
    width: 10px;
    height: 20px;
    background: white;
    border-bottom-right-radius: 10px;
  }
`;

export const SMSPreview = (props: {
  text?: string;
  time?: string;
}): JSX.Element => {
  const [segments, setSegments] = useState<SegmentedMessage>();
  useEffect(() => {
    const segments = new SegmentedMessage(props.text ?? '');
    setSegments(segments);
  }, [props.text]);
  return (
    <Row justify="center">
      <Col
        span={22}
        style={{
          paddingTop: '20px',
          maxWidth: '400px',
          overflow: 'hidden'
        }}
      >
        <img
          alt="iMessage Mock"
          style={{
            width: '100%',
            position: 'absolute',
            marginBottom: '12px',
            filter: 'opacity(0.87)'
          }}
          src={iMessageMock}
        />
        <div
          style={{
            position: 'absolute',
            top: '15%',
            right: '75%',
            padding: '5px 5px',
            borderRadius: '5px',
            fontSize: '12px',
            color: 'black'
          }}
        >
          {props.time}
        </div>
        <MessageWrapper>
          <div className={'yours messages'}>
            <div data-cy="SMS_text" className="message last">
              <TextArea
                style={{
                  width: '100%',
                  pointerEvents: 'none',
                  fontSize: '14px',
                  fontFamily:
                    '"-apple-system,".SFNSText-Regular","San Francisco"'
                }}
                value={props.text}
                autoSize={true}
                bordered={false}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '8px',
                  bottom: '8px',
                  fontFamily:
                    '"-apple-system,".SFNSText-Regular","San Francisco"'
                }}
              >
                <Popover
                  placement="left"
                  overlayStyle={{ width: '400px' }}
                  content={
                    <>
                      <Paragraph>
                        Number of Segments: {segments?.segmentsCount}
                      </Paragraph>
                      <Paragraph>
                        An SMS segment holds up to 160 characters, or 70
                        characters for a Unicode SMS (when using emojis or
                        international characters). If your SMS exceeds this
                        limit, it will be split into multiple segments. Your
                        usage is calculated based on the number of segments
                        sent.
                      </Paragraph>
                    </>
                  }
                >
                  <Text type="secondary" style={{ fontSize: '8px' }}>
                    ({segments?.segmentsCount})
                  </Text>
                </Popover>
              </div>
            </div>
          </div>
        </MessageWrapper>
      </Col>
    </Row>
  );
};
